module.exports = __webpack_public_path__ + "static/media/compare_connect_icons.0f5d06cc.png";